import { UnknownAction } from "redux"
import { userAuthTypes } from "./auth.types"
import { IAuthData } from "./auth.reducer"



export const setIsLoadingAction = (isLoading: boolean) : UnknownAction => {
    return {
        type: userAuthTypes.IS_LOADING,
        payload: isLoading
    }
}

export const setAuthDataAction = (authData: IAuthData | null | undefined) : UnknownAction => {
    return {
        type: userAuthTypes.SET_AUTH_DATA,
        payload: authData
    }
}

export const setLastOrganizationIdLoggedAction = (organizationId: string | null) : UnknownAction => {
    return {
        type: userAuthTypes.SET_LAST_ORGANIZATION_ID_LOGGED,
        payload: organizationId
    }
}